import { render } from "./App.vue?vue&type=template&id=7d8b6d01"
const script = {}

import "./App.vue?vue&type=style&index=0&id=7d8b6d01&lang=scss"

import exportComponent from "D:\\桌面\\项目\\网站\\宠趣SDK\\chongQu_ldy\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__